import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const trialWebsiteApi = {
    getTrialWebsiteByTrialId: (trialId: number): Observable<Dtos.GetTrialWebsiteByTrialIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialWebsiteByTrialId = new Dtos.GetTrialWebsiteByTrialId();
        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.GetTrialWebsiteByTrialIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getTrialWebsiteById: (id: number): Observable<Dtos.GetTrialWebsiteByIdResponse> => {
        //Create the request.
        let request: Dtos.GetTrialWebsiteById = new Dtos.GetTrialWebsiteById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetTrialWebsiteByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setTrialWebsite: (trialWebsite: Dtos.TrialWebsite): Observable<Dtos.SetTrialWebsiteResponse> => {

        let request: Dtos.SetTrialWebsite = new Dtos.SetTrialWebsite();

        request.trialWebsite = trialWebsite;

        // send request
        const response: Promise<Dtos.SetTrialWebsiteResponse> = client.post(request);

        return Observable.from(response);
    },
    createTrialWebsite: (trialId: number): Observable<Dtos.CreateTrialWebsiteResponse> => {
        //Create the request.
        let request: Dtos.CreateTrialWebsite = new Dtos.CreateTrialWebsite();

        request.trialId = trialId;

        //Send request.
        const response: Promise<Dtos.CreateTrialWebsiteResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateTrialWebsite: (trialWebsite: Dtos.TrialWebsite): Observable<Dtos.ValidateTrialWebsiteResponse> => {

        let request: Dtos.ValidateTrialWebsite = new Dtos.ValidateTrialWebsite();

        request.trialWebsite = trialWebsite;

        // send request
        const response: Promise<Dtos.ValidateTrialWebsiteResponse> = client.post(request);

        return Observable.from(response);
    },
}